<template>
  <div class="dialog-merchant-pay-info-wrapper">
    <el-dialog title="修改商户支付配置" :visible="visible" @open="onDialogOpen" @close="onDialogClose">
      <el-form label-position="top" ref="merchantPayInfoForm" :rules="merchantPayInfoRules" :model="merchantPayInfoForm">

        <el-form-item label="当前使用支付渠道" prop="now_pay_channel">
          <el-select v-model="merchantPayInfoForm.nowPayChannel" placeholder="请选择设备类型">
            <el-option label="京东" value="jd"></el-option>
            <el-option label="扫呗" value="sb"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="京东审核状态" prop="jd_review">
          <el-select v-model="merchantPayInfoForm.jdReview" placeholder="请选择京东审核状态">
            <el-option label="未审核" :value="0"></el-option>
            <el-option label="审核中" :value="1"></el-option>
            <el-option label="审核通过" :value="2"></el-option>
            <el-option label="审核不通过" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="扫呗审核状态" prop="sb_review">
          <el-select v-model="merchantPayInfoForm.sbReview" placeholder="请选择扫呗审核状态">
            <el-option label="未审核" :value="0"></el-option>
            <el-option label="审核中" :value="1"></el-option>
            <el-option label="审核通过" :value="2"></el-option>
            <el-option label="审核不通过" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <div class="submit-wrapper">
          <el-button
            type="danger"
            size="medium"
            @click="onFormSubmit">保存</el-button>
          <el-button
            size="medium"
            @click="onFormCancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DialogMerchantPayInfo',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    updatingMerchant: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      merchantPayInfoForm: {
        nowPayChannel: '',
        jdReview: 0,
        sbReview: 0
      },
      merchantPayInfoRules: {
        nowPayChannel: [
          { required: true, message: '请选择支付渠道', trigger: 'change' }
        ],
        sbReview: [
          { required: true, message: '请选择扫呗渠道的审核状态', trigger: 'change' }
        ],
        jdReview: [
          { required: true, message: '请选择京东渠道的审核状态', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    ...mapActions('bank', [
      'updateMerchantPayInfo'
    ]),

    async onFormSubmit () {
      this.$refs['merchantPayInfoForm'].validate(async valid => {
        if (valid) {
          try {
            await this.updateMerchantPayInfo({
              merchantId: this.updatingMerchant.merchant_id,
              nowPayChannel: this.merchantPayInfoForm.nowPayChannel,
              jdReview: this.merchantPayInfoForm.jdReview,
              sbReview: this.merchantPayInfoForm.sbReview
            })

            this.$message({
              type: 'success',
              message: '更新支付配置成功'
            })

            this.$emit('data-change')
            this.$emit('update:visible', false)
          } catch (err) {
            console.log(err)
          }
        } else {
          return false
        }
      })
    },
    onFormCancel () {
      this.$emit('update:visible', false)
    },

    onDialogOpen () {
      this.merchantPayInfoForm.nowPayChannel = this.updatingMerchant.now_pay_channel
      this.merchantPayInfoForm.jdReview = this.updatingMerchant.jd_review
      this.merchantPayInfoForm.sbReview = this.updatingMerchant.sb_review
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-merchant-pay-info-wrapper {

  .submit-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 18%;
    margin: 2rem auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bank/DialogMerchantPayInfo.vue